<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest} width="155" height="16" viewBox="0 0 155 16">
	<path
		d="M33.6096 3.01703V0.000209477H23.9905V16H33.7224V12.9828H27.0918V9.3941H33.0481V6.4228H27.0918V3.01703H33.6096Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M3.10168 6.35432V0H0V15.9998H3.10168V9.37156H8.94536V15.9998H12.0247V0H8.94536V6.35432H3.10168Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M53.9694 9.76009L47.2265 0H44.8666V15.9998H47.9682V6.21736L54.7111 15.9998H57.0711V0H53.9694V9.76009Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M72 15.9998V0H68.8987V15.9998H72Z" fill={getTailwindColor(color)} />
	<path
		d="M87.7848 15.7109V3.39339H87.917L95.8937 15.7109H97.7887V0.286455H96.0259V12.604H95.8937L87.8289 0.286455H86V15.7109H87.7848Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M114.613 15.7109V14.1024H107.363V8.65975H113.401V7.05119H107.363V1.91704H114.371V0.286455H105.579V15.7109H114.613Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M123.465 15.7109H125.779L129.239 2.68827H129.371L132.83 15.7109H135.144L139.088 0.286455H137.171L134.02 13.5295H133.888L130.428 0.286455H128.181L124.721 13.5295H124.589L121.438 0.286455H119.521L123.465 15.7109Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M143.89 11.1277C143.846 13.9261 146.38 16.0855 149.398 15.9974C151.029 15.9974 152.329 15.5787 153.299 14.7634C154.268 13.9261 154.753 12.8905 154.753 11.6345C154.753 5.39857 146.203 8.32922 146.203 4.12054C146.203 2.73234 147.283 1.63059 149.332 1.63059C151.426 1.63059 152.594 2.7103 152.594 4.4731H154.422C154.422 1.30006 151.668 0 149.354 0C147.856 0 146.666 0.39663 145.763 1.21192C144.859 2.00518 144.419 2.97472 144.419 4.12054C144.419 10.2903 152.946 6.89695 152.946 11.7446C152.946 13.3312 151.514 14.3448 149.465 14.3448C148.319 14.3448 147.393 14.0363 146.71 13.4193C146.027 12.8023 145.675 12.0311 145.675 11.1277H143.89Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
